import { apiConfig } from "./apiConfig";
export function mrApplianceBrandList(successHandler:any){
    var conceptid = 8;
     $.ajax({
        url: apiConfig.serviceAggregates + conceptid + '/makes?&apikey=' + window.DEFINE_VALUE.JS_API_KEY,
        dataType: 'json',
        type: 'GET',
        success: successHandler,
        error: function (e:any){
        }
    });
}